import React from 'react'
import HomePageMHeader from '../components/homepagemheader/HomePageMHeader'
import styled from 'styled-components'
import WomenPage from '../components/womenpage/WomenPage'
const Screen = styled.div`
max-width: 1920px !important;
background:white;
`
const Women = () => {
  return (
    <Screen className='container mx-auto w-full  flex-grow'>
    <HomePageMHeader />
    <WomenPage />
    </Screen>

  )
}

export default Women